import PageTitle from "../ui/PageTitle";
import { useState } from "react";
import axios from "axios";
import { getPrefix, getSessionToken } from "../../lib/bandung/bandung";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";
import {useLoaderData} from "react-router-dom";

const PendingEvents = () => {
  
  const snackbarInfo = useInfoSnackbar(2000, "bottom", "right");
  const [events, setEvents] = useState(useLoaderData());

  const handleApprove = (eventEntityId) => {
    try {
      axios
        .get(`${getPrefix()}/app/event/approve?eventEntityId=${eventEntityId}&sessionToken=${getSessionToken()}`)
        .then((res) => {
          if (res.data.eventEntityId === eventEntityId) {
            const newEvents = events.filter(
                (e) => e.eventEntityId !== eventEntityId
            );
            setEvents(newEvents);
            snackbarInfo.alertSuccess("You have approved event #" + eventEntityId);
          } else {
            snackbarInfo.alertError(res.error);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleReject = (eventEntityId) => {
    try {
      axios
        .get(`${getPrefix()}/app/event/reject?eventEntityId=${eventEntityId}&sessionToken=${getSessionToken()}`)
        .then((res) => {
          if (res.data.eventEntityId === eventEntityId) {
            const newEvents = events.filter(
                (e) => e.eventEntityId !== eventEntityId
            );
            setEvents(newEvents);
            snackbarInfo.alertInfo("You have rejected event #" + eventEntityId);
          } else {
            snackbarInfo.alertError(res.error);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Pending Events"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "event", path: "/event" },
              { name: "pending", path: "/event/pending" },
            ]}
          />
        </div>

        <div className="aboutus-wrapper w-full">
          <div className="container-x mx-auto py-10">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Label</TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Start Date
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      End Date
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      Start Time
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                      End Time
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {events.map((event) => (
                      !event.rejectDate &&
                      (<TableRow
                      key={event.eventEntityId}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                      <TableCell component="th" scope="row">
                        {event.label}
                      </TableCell>
                      <TableCell align="right">{event.startDate}</TableCell>
                      <TableCell align="right">{event.endDate}</TableCell>
                      <TableCell align="right">{event.startTime}</TableCell>
                      <TableCell align="right">{event.endTime}</TableCell>
                      {/* <TableCell align="center">{event.schedule}</TableCell> */}
                      <TableCell align="center">
                          <Button
                              variant="contained"
                              sx={{ mr: 2 }}
                              onClick={() => handleApprove(event.eventEntityId)}
                          >
                            Approve
                          </Button>
                          <Button
                              variant="contained"
                              color="error"
                              onClick={() => handleReject(event.eventEntityId)}
                          >
                              Reject
                          </Button>
                      </TableCell>
                    </TableRow>)
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingEvents;
